var $ = require("../lib/qsa");
// var player = require("./player");
var View = require("./view");

module.exports = class TextView extends View {
  constructor() {
    super();
  }

  enter(slide) {
    super.enter(slide);
  }
};
